import QRCode from "qrcode";

interface GenerateQRParams {
  upiId: string;
  name: string;
  amount: string;
}

export const generateUPIQRCode = async ({
  upiId,
  name,
  amount,
}: GenerateQRParams) => {

  try {

    const upiString =
      `upi://pay?pa=${encodeURIComponent(upiId)}&pn=${encodeURIComponent(name)}&am=${amount}&cu=INR`;

    console.log("UPI STRING:", upiString);

    const qrCodeDataURL = await QRCode.toDataURL(upiString, {
      width: 300,
      margin: 2,
    });

    return {
      qrCodeDataURL,
      upiString,
    };

  } catch (error) {

    console.error("QR Generation Error:", error);
    return null;
  }
};